/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionRef,
  BalanceTransactionRefOptional,
  BalanceTransactionRefMetaI,
  BalanceTransactionRefTrackedI,
} from "./balance-transaction-ref";
import {
  BalanceTransactionRefTracked,
  BalanceTransactionRefMeta,
} from "./balance-transaction-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashTransactionRef,
  CashTransactionRefOptional,
  CashTransactionRefMetaI,
  CashTransactionRefTrackedI,
} from "./cash-transaction-ref";
import {
  CashTransactionRefTracked,
  CashTransactionRefMeta,
} from "./cash-transaction-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentBase,
  OrderPaymentBaseOptional,
  OrderPaymentBaseMetaI,
  OrderPaymentBaseTrackedI,
} from "./order-payment-base";
import {
  OrderPaymentBaseTracked,
  OrderPaymentBaseMeta,
} from "./order-payment-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentRef,
  OrderPaymentRefOptional,
  OrderPaymentRefMetaI,
  OrderPaymentRefTrackedI,
} from "./order-payment-ref";
import {
  OrderPaymentRefTracked,
  OrderPaymentRefMeta,
} from "./order-payment-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentSourceRef,
  PaymentSourceRefOptional,
  PaymentSourceRefMetaI,
  PaymentSourceRefTrackedI,
} from "./payment-source-ref";
import {
  PaymentSourceRefTracked,
  PaymentSourceRefMeta,
} from "./payment-source-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentStatus,
  PaymentStatusOptional,
  PaymentStatusMetaI,
  PaymentStatusTrackedI,
} from "./payment-status";
import { PaymentStatusTracked, PaymentStatusMeta } from "./payment-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  StripeTransactionRef,
  StripeTransactionRefOptional,
  StripeTransactionRefMetaI,
  StripeTransactionRefTrackedI,
} from "./stripe-transaction-ref";
import {
  StripeTransactionRefTracked,
  StripeTransactionRefMeta,
} from "./stripe-transaction-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TransactionOtherRef,
  TransactionOtherRefOptional,
  TransactionOtherRefMetaI,
  TransactionOtherRefTrackedI,
} from "./transaction-other-ref";
import {
  TransactionOtherRefTracked,
  TransactionOtherRefMeta,
} from "./transaction-other-ref";

/**
 *
 * @export
 * @interface OrderPaymentFull
 */
export interface OrderPaymentFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentFull
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentFull
   */
  paymentStatus?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentFull
   */
  expiresOn?: Date;
  /**
   *
   * @type {PaymentSourceRef}
   * @memberof OrderPaymentFull
   */
  paymentSource?: PaymentSourceRefOptional;
  /**
   *
   * @type {StripeTransactionRef}
   * @memberof OrderPaymentFull
   */
  stripeTransaction?: StripeTransactionRefOptional;
  /**
   *
   * @type {CashTransactionRef}
   * @memberof OrderPaymentFull
   */
  cashTransaction?: CashTransactionRefOptional;
  /**
   *
   * @type {BalanceTransactionRef}
   * @memberof OrderPaymentFull
   */
  balanceTransaction?: BalanceTransactionRefOptional;
  /**
   *
   * @type {TransactionOtherRef}
   * @memberof OrderPaymentFull
   */
  transactionOther?: TransactionOtherRefOptional;
}

export interface OrderPaymentFull
  extends
    OrderPaymentFullOptional,
    Deletable,
    OrderPaymentBase,
    OrderPaymentRef {
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentServiceChangeCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentCapturableCents?: number;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentCapturableDate?: Date;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentTotalCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentRefundedCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentToRefundCents?: number;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentFull
   */
  paymentType: PaymentType;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentRecordId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentFull
   */
  paymentStatus: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentDueDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentPaidDate?: Date;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  squarePaymentId?: string;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentFull
   */
  expiresOn?: Date;
  /**
   *
   * @type {PaymentSourceRef}
   * @memberof OrderPaymentFull
   */
  paymentSource?: PaymentSourceRef;
  /**
   *
   * @type {StripeTransactionRef}
   * @memberof OrderPaymentFull
   */
  stripeTransaction?: StripeTransactionRef;
  /**
   *
   * @type {CashTransactionRef}
   * @memberof OrderPaymentFull
   */
  cashTransaction?: CashTransactionRef;
  /**
   *
   * @type {BalanceTransactionRef}
   * @memberof OrderPaymentFull
   */
  balanceTransaction?: BalanceTransactionRef;
  /**
   *
   * @type {TransactionOtherRef}
   * @memberof OrderPaymentFull
   */
  transactionOther?: TransactionOtherRef;
}

export interface OrderPaymentFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderPaymentFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentServiceChangeCents?: number;
  paymentServiceChangeCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentCapturableCents?: number;
  paymentCapturableCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentCapturableDate?: Date;
  paymentCapturableDateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentPaidCents?: number;
  paymentPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentTotalCents?: number;
  paymentTotalCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentRefundedCents?: number;
  paymentRefundedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderPaymentFull
   */
  paymentToRefundCents?: number;
  paymentToRefundCentsIsSet: boolean;
  /**
   *
   * @type {PaymentType}
   * @memberof OrderPaymentFull
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentRecordId?: string;
  paymentRecordIdIsSet: boolean;
  /**
   *
   * @type {PaymentStatus}
   * @memberof OrderPaymentFull
   */
  paymentStatus?: PaymentStatus;
  paymentStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentDueDate?: Date;
  paymentDueDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  paymentPaidDate?: Date;
  paymentPaidDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderPaymentFull
   */
  squarePaymentId?: string;
  squarePaymentIdIsSet: boolean;
  /**
   * Timestamp when this payment expires and should be automatically cancelled
   * @type {string}
   * @memberof OrderPaymentFull
   */
  expiresOn?: Date;
  expiresOnIsSet: boolean;
  /**
   *
   * @type {PaymentSourceRef}
   * @memberof OrderPaymentFull
   */
  paymentSource?: PaymentSourceRefTrackedI;
  paymentSourceIsSet: boolean;
  /**
   *
   * @type {StripeTransactionRef}
   * @memberof OrderPaymentFull
   */
  stripeTransaction?: StripeTransactionRefTrackedI;
  stripeTransactionIsSet: boolean;
  /**
   *
   * @type {CashTransactionRef}
   * @memberof OrderPaymentFull
   */
  cashTransaction?: CashTransactionRefTrackedI;
  cashTransactionIsSet: boolean;
  /**
   *
   * @type {BalanceTransactionRef}
   * @memberof OrderPaymentFull
   */
  balanceTransaction?: BalanceTransactionRefTrackedI;
  balanceTransactionIsSet: boolean;
  /**
   *
   * @type {TransactionOtherRef}
   * @memberof OrderPaymentFull
   */
  transactionOther?: TransactionOtherRefTrackedI;
  transactionOtherIsSet: boolean;
}

transformDatesMap.set("OrderPaymentFull", function (model: OrderPaymentFull) {
  if (typeof model.paymentCapturableDate == "string")
    model.paymentCapturableDate = new Date(model.paymentCapturableDate);
  if (typeof model.paymentDueDate == "string")
    model.paymentDueDate = new Date(model.paymentDueDate);
  if (typeof model.paymentPaidDate == "string")
    model.paymentPaidDate = new Date(model.paymentPaidDate);
  if (typeof model.expiresOn == "string")
    model.expiresOn = new Date(model.expiresOn);
  const transformDatespaymentSource = transformDatesMap.get("PaymentSourceRef");
  if (transformDatespaymentSource && model.paymentSource) {
    transformDatespaymentSource(model.paymentSource);
  }
  const transformDatesstripeTransaction = transformDatesMap.get(
    "StripeTransactionRef",
  );
  if (transformDatesstripeTransaction && model.stripeTransaction) {
    transformDatesstripeTransaction(model.stripeTransaction);
  }
  const transformDatescashTransaction =
    transformDatesMap.get("CashTransactionRef");
  if (transformDatescashTransaction && model.cashTransaction) {
    transformDatescashTransaction(model.cashTransaction);
  }
  const transformDatesbalanceTransaction = transformDatesMap.get(
    "BalanceTransactionRef",
  );
  if (transformDatesbalanceTransaction && model.balanceTransaction) {
    transformDatesbalanceTransaction(model.balanceTransaction);
  }
  const transformDatestransactionOther = transformDatesMap.get(
    "TransactionOtherRef",
  );
  if (transformDatestransactionOther && model.transactionOther) {
    transformDatestransactionOther(model.transactionOther);
  }
});

export type OrderPaymentFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentServiceChangeCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentCapturableCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  paymentCapturableDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentRefundedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentToRefundCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentRecordId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentStatus: PropertyMeta<PaymentStatusMetaI>;
  //isDate: false
  //isDatetime: true
  paymentDueDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  paymentPaidDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  squarePaymentId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  expiresOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  paymentSource: PropertyMeta<PaymentSourceRefMetaI>;
  //isDate: false
  //isDatetime: false
  stripeTransaction: PropertyMeta<StripeTransactionRefMetaI>;
  //isDate: false
  //isDatetime: false
  cashTransaction: PropertyMeta<CashTransactionRefMetaI>;
  //isDate: false
  //isDatetime: false
  balanceTransaction: PropertyMeta<BalanceTransactionRefMetaI>;
  //isDate: false
  //isDatetime: false
  transactionOther: PropertyMeta<TransactionOtherRefMetaI>;
}>;

export var OrderPaymentFullMeta: OrderPaymentFullMetaI =
  {} as OrderPaymentFullMetaI;
OrderPaymentFullMeta = typeMeta("OrderPaymentFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  paymentServiceChangeCents: propertyMeta(
    "paymentServiceChangeCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableCents: propertyMeta(
    "paymentCapturableCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentCapturableDate: propertyMeta(
    "paymentCapturableDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidCents: propertyMeta(
    "paymentPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentTotalCents: propertyMeta(
    "paymentTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentRefundedCents: propertyMeta(
    "paymentRefundedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentToRefundCents: propertyMeta(
    "paymentToRefundCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  paymentType: propertyMeta("paymentType", false, true, false, PaymentTypeMeta),
  paymentRecordId: propertyMeta(
    "paymentRecordId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  paymentStatus: propertyMeta(
    "paymentStatus",
    false,
    true,
    false,
    PaymentStatusMeta,
  ),
  paymentDueDate: propertyMeta(
    "paymentDueDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  paymentPaidDate: propertyMeta(
    "paymentPaidDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  squarePaymentId: propertyMeta(
    "squarePaymentId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  expiresOn: propertyMeta("expiresOn", false, false, false, MetaTypesBase.Date),
  paymentSource: propertyMeta(
    "paymentSource",
    false,
    false,
    false,
    PaymentSourceRefMeta,
  ),
  stripeTransaction: propertyMeta(
    "stripeTransaction",
    false,
    false,
    false,
    StripeTransactionRefMeta,
  ),
  cashTransaction: propertyMeta(
    "cashTransaction",
    false,
    false,
    false,
    CashTransactionRefMeta,
  ),
  balanceTransaction: propertyMeta(
    "balanceTransaction",
    false,
    false,
    false,
    BalanceTransactionRefMeta,
  ),
  transactionOther: propertyMeta(
    "transactionOther",
    false,
    false,
    false,
    TransactionOtherRefMeta,
  ),
});

const metaI = OrderPaymentFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentRefMeta]);
  metaI.assignId.inheritedFrom = OrderPaymentRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([OrderPaymentBaseMeta]);
  metaI.paymentServiceChangeCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentServiceChangeCents;
  metaI.paymentCapturableCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentCapturableCents;
  metaI.paymentCapturableDate.inheritedFrom =
    OrderPaymentBaseMeta.paymentCapturableDate;
  metaI.paymentPaidCents.inheritedFrom = OrderPaymentBaseMeta.paymentPaidCents;
  metaI.paymentTotalCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentTotalCents;
  metaI.paymentRefundedCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentRefundedCents;
  metaI.paymentToRefundCents.inheritedFrom =
    OrderPaymentBaseMeta.paymentToRefundCents;
  metaI.paymentType.inheritedFrom = OrderPaymentBaseMeta.paymentType;
  metaI.paymentRecordId.inheritedFrom = OrderPaymentBaseMeta.paymentRecordId;
  metaI.paymentStatus.inheritedFrom = OrderPaymentBaseMeta.paymentStatus;
  metaI.paymentDueDate.inheritedFrom = OrderPaymentBaseMeta.paymentDueDate;
  metaI.paymentPaidDate.inheritedFrom = OrderPaymentBaseMeta.paymentPaidDate;
  metaI.squarePaymentId.inheritedFrom = OrderPaymentBaseMeta.squarePaymentId;
  metaI.expiresOn.inheritedFrom = OrderPaymentBaseMeta.expiresOn;
});

export class OrderPaymentFullTracked
  extends DeletableTracked
  implements OrderPaymentFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  paymentServiceChangeCents__I?: number = undefined;
  paymentServiceChangeCentsIsSet: boolean = false;
  set paymentServiceChangeCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentServiceChangeCents__I = v;
      this.paymentServiceChangeCentsIsSet = true;
    } else {
      this.paymentServiceChangeCents__I = v || undefined;
      this.paymentServiceChangeCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentServiceChangeCents() {
    return this.paymentServiceChangeCents__I;
  }
  paymentCapturableCents__I?: number = undefined;
  paymentCapturableCentsIsSet: boolean = false;
  set paymentCapturableCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentCapturableCents__I = v;
      this.paymentCapturableCentsIsSet = true;
    } else {
      this.paymentCapturableCents__I = v || undefined;
      this.paymentCapturableCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableCents() {
    return this.paymentCapturableCents__I;
  }
  paymentCapturableDate__I?: Date = undefined;
  paymentCapturableDateIsSet: boolean = false;
  set paymentCapturableDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentCapturableDate__I = v;
      this.paymentCapturableDateIsSet = true;
    } else {
      this.paymentCapturableDate__I = v || undefined;
      this.paymentCapturableDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentCapturableDate() {
    return this.paymentCapturableDate__I;
  }
  paymentPaidCents__I?: number = undefined;
  paymentPaidCentsIsSet: boolean = false;
  set paymentPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentPaidCents__I = v;
      this.paymentPaidCentsIsSet = true;
    } else {
      this.paymentPaidCents__I = v || undefined;
      this.paymentPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidCents() {
    return this.paymentPaidCents__I;
  }
  paymentTotalCents__I?: number = undefined;
  paymentTotalCentsIsSet: boolean = false;
  set paymentTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentTotalCents__I = v;
      this.paymentTotalCentsIsSet = true;
    } else {
      this.paymentTotalCents__I = v || undefined;
      this.paymentTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTotalCents() {
    return this.paymentTotalCents__I;
  }
  paymentRefundedCents__I?: number = undefined;
  paymentRefundedCentsIsSet: boolean = false;
  set paymentRefundedCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentRefundedCents__I = v;
      this.paymentRefundedCentsIsSet = true;
    } else {
      this.paymentRefundedCents__I = v || undefined;
      this.paymentRefundedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRefundedCents() {
    return this.paymentRefundedCents__I;
  }
  paymentToRefundCents__I?: number = undefined;
  paymentToRefundCentsIsSet: boolean = false;
  set paymentToRefundCents(v: undefined | number) {
    if (v !== undefined) {
      this.paymentToRefundCents__I = v;
      this.paymentToRefundCentsIsSet = true;
    } else {
      this.paymentToRefundCents__I = v || undefined;
      this.paymentToRefundCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentToRefundCents() {
    return this.paymentToRefundCents__I;
  }
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentRecordId__I?: string = undefined;
  paymentRecordIdIsSet: boolean = false;
  set paymentRecordId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentRecordId__I = v;
      this.paymentRecordIdIsSet = true;
    } else {
      this.paymentRecordId__I = v || undefined;
      this.paymentRecordIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentRecordId() {
    return this.paymentRecordId__I;
  }
  paymentStatus__I?: PaymentStatus = undefined;
  paymentStatusIsSet: boolean = false;
  set paymentStatus(v: undefined | PaymentStatus) {
    if (v !== undefined) {
      this.paymentStatus__I = v;
      this.paymentStatusIsSet = true;
    } else {
      this.paymentStatus__I = v || undefined;
      this.paymentStatusIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentStatus() {
    return this.paymentStatus__I;
  }
  paymentDueDate__I?: Date = undefined;
  paymentDueDateIsSet: boolean = false;
  set paymentDueDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentDueDate__I = v;
      this.paymentDueDateIsSet = true;
    } else {
      this.paymentDueDate__I = v || undefined;
      this.paymentDueDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentDueDate() {
    return this.paymentDueDate__I;
  }
  paymentPaidDate__I?: Date = undefined;
  paymentPaidDateIsSet: boolean = false;
  set paymentPaidDate(v: undefined | Date) {
    if (v !== undefined) {
      this.paymentPaidDate__I = v;
      this.paymentPaidDateIsSet = true;
    } else {
      this.paymentPaidDate__I = v || undefined;
      this.paymentPaidDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentPaidDate() {
    return this.paymentPaidDate__I;
  }
  squarePaymentId__I?: string = undefined;
  squarePaymentIdIsSet: boolean = false;
  set squarePaymentId(v: undefined | string) {
    if (v !== undefined) {
      this.squarePaymentId__I = v;
      this.squarePaymentIdIsSet = true;
    } else {
      this.squarePaymentId__I = v || undefined;
      this.squarePaymentIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squarePaymentId() {
    return this.squarePaymentId__I;
  }
  expiresOn__I?: Date = undefined;
  expiresOnIsSet: boolean = false;
  set expiresOn(v: undefined | Date) {
    if (v !== undefined) {
      this.expiresOn__I = v;
      this.expiresOnIsSet = true;
    } else {
      this.expiresOn__I = v || undefined;
      this.expiresOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get expiresOn() {
    return this.expiresOn__I;
  }
  paymentSource__I?: PaymentSourceRefTracked = undefined;
  paymentSourceIsSet: boolean = false;
  set paymentSource(v: undefined | PaymentSourceRefTracked) {
    if (v !== undefined) {
      this.paymentSource__I = v;
      this.paymentSourceIsSet = true;
    } else {
      this.paymentSource__I = v || undefined;
      this.paymentSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentSource() {
    return this.paymentSource__I;
  }
  stripeTransaction__I?: StripeTransactionRefTracked = undefined;
  stripeTransactionIsSet: boolean = false;
  set stripeTransaction(v: undefined | StripeTransactionRefTracked) {
    if (v !== undefined) {
      this.stripeTransaction__I = v;
      this.stripeTransactionIsSet = true;
    } else {
      this.stripeTransaction__I = v || undefined;
      this.stripeTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripeTransaction() {
    return this.stripeTransaction__I;
  }
  cashTransaction__I?: CashTransactionRefTracked = undefined;
  cashTransactionIsSet: boolean = false;
  set cashTransaction(v: undefined | CashTransactionRefTracked) {
    if (v !== undefined) {
      this.cashTransaction__I = v;
      this.cashTransactionIsSet = true;
    } else {
      this.cashTransaction__I = v || undefined;
      this.cashTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashTransaction() {
    return this.cashTransaction__I;
  }
  balanceTransaction__I?: BalanceTransactionRefTracked = undefined;
  balanceTransactionIsSet: boolean = false;
  set balanceTransaction(v: undefined | BalanceTransactionRefTracked) {
    if (v !== undefined) {
      this.balanceTransaction__I = v;
      this.balanceTransactionIsSet = true;
    } else {
      this.balanceTransaction__I = v || undefined;
      this.balanceTransactionIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceTransaction() {
    return this.balanceTransaction__I;
  }
  transactionOther__I?: TransactionOtherRefTracked = undefined;
  transactionOtherIsSet: boolean = false;
  set transactionOther(v: undefined | TransactionOtherRefTracked) {
    if (v !== undefined) {
      this.transactionOther__I = v;
      this.transactionOtherIsSet = true;
    } else {
      this.transactionOther__I = v || undefined;
      this.transactionOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionOther() {
    return this.transactionOther__I;
  }
  constructor(config?: OrderPaymentFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.paymentSource?.setIds();

    this.stripeTransaction?.setIds();

    this.cashTransaction?.setIds();

    this.balanceTransaction?.setIds();

    this.transactionOther?.setIds();
  }
  assignFrom(
    config: OrderPaymentFullOptional,
    options?: AssignOptions,
  ): OrderPaymentFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.paymentServiceChangeCents &&
      this.paymentServiceChangeCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentServiceChangeCents = config.paymentServiceChangeCents;
      if (optionsRequired.unassign) this.paymentServiceChangeCentsIsSet = false;
      else this.paymentServiceChangeCentsIsSet = true;
    }
    if (
      config.paymentCapturableCents &&
      this.paymentCapturableCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableCents = config.paymentCapturableCents;
      if (optionsRequired.unassign) this.paymentCapturableCentsIsSet = false;
      else this.paymentCapturableCentsIsSet = true;
    }
    if (
      config.paymentCapturableDate &&
      this.paymentCapturableDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentCapturableDate = config.paymentCapturableDate;
      if (optionsRequired.unassign) this.paymentCapturableDateIsSet = false;
      else this.paymentCapturableDateIsSet = true;
    }
    if (
      config.paymentPaidCents &&
      this.paymentPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidCents = config.paymentPaidCents;
      if (optionsRequired.unassign) this.paymentPaidCentsIsSet = false;
      else this.paymentPaidCentsIsSet = true;
    }
    if (
      config.paymentTotalCents &&
      this.paymentTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTotalCents = config.paymentTotalCents;
      if (optionsRequired.unassign) this.paymentTotalCentsIsSet = false;
      else this.paymentTotalCentsIsSet = true;
    }
    if (
      config.paymentRefundedCents &&
      this.paymentRefundedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRefundedCents = config.paymentRefundedCents;
      if (optionsRequired.unassign) this.paymentRefundedCentsIsSet = false;
      else this.paymentRefundedCentsIsSet = true;
    }
    if (
      config.paymentToRefundCents &&
      this.paymentToRefundCentsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentToRefundCents = config.paymentToRefundCents;
      if (optionsRequired.unassign) this.paymentToRefundCentsIsSet = false;
      else this.paymentToRefundCentsIsSet = true;
    }
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentRecordId &&
      this.paymentRecordIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentRecordId = config.paymentRecordId;
      if (optionsRequired.unassign) this.paymentRecordIdIsSet = false;
      else this.paymentRecordIdIsSet = true;
    }
    if (
      config.paymentStatus &&
      this.paymentStatusApplyFilter(optionsRequired.filter)
    ) {
      this.paymentStatus = config.paymentStatus;
      if (optionsRequired.unassign) this.paymentStatusIsSet = false;
      else this.paymentStatusIsSet = true;
    }
    if (
      config.paymentDueDate &&
      this.paymentDueDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentDueDate = config.paymentDueDate;
      if (optionsRequired.unassign) this.paymentDueDateIsSet = false;
      else this.paymentDueDateIsSet = true;
    }
    if (
      config.paymentPaidDate &&
      this.paymentPaidDateApplyFilter(optionsRequired.filter)
    ) {
      this.paymentPaidDate = config.paymentPaidDate;
      if (optionsRequired.unassign) this.paymentPaidDateIsSet = false;
      else this.paymentPaidDateIsSet = true;
    }
    if (
      config.squarePaymentId &&
      this.squarePaymentIdApplyFilter(optionsRequired.filter)
    ) {
      this.squarePaymentId = config.squarePaymentId;
      if (optionsRequired.unassign) this.squarePaymentIdIsSet = false;
      else this.squarePaymentIdIsSet = true;
    }
    if (config.expiresOn && this.expiresOnApplyFilter(optionsRequired.filter)) {
      this.expiresOn = config.expiresOn;
      if (optionsRequired.unassign) this.expiresOnIsSet = false;
      else this.expiresOnIsSet = true;
    }
    if (
      config.paymentSource &&
      this.paymentSourceApplyFilter(optionsRequired.filter)
    ) {
      this.paymentSource = new PaymentSourceRefTracked(
        config.paymentSource,
        options,
      );
      if (optionsRequired.unassign) this.paymentSourceIsSet = false;
      else this.paymentSourceIsSet = true;
    }
    if (
      config.stripeTransaction &&
      this.stripeTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.stripeTransaction = new StripeTransactionRefTracked(
        config.stripeTransaction,
        options,
      );
      if (optionsRequired.unassign) this.stripeTransactionIsSet = false;
      else this.stripeTransactionIsSet = true;
    }
    if (
      config.cashTransaction &&
      this.cashTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.cashTransaction = new CashTransactionRefTracked(
        config.cashTransaction,
        options,
      );
      if (optionsRequired.unassign) this.cashTransactionIsSet = false;
      else this.cashTransactionIsSet = true;
    }
    if (
      config.balanceTransaction &&
      this.balanceTransactionApplyFilter(optionsRequired.filter)
    ) {
      this.balanceTransaction = new BalanceTransactionRefTracked(
        config.balanceTransaction,
        options,
      );
      if (optionsRequired.unassign) this.balanceTransactionIsSet = false;
      else this.balanceTransactionIsSet = true;
    }
    if (
      config.transactionOther &&
      this.transactionOtherApplyFilter(optionsRequired.filter)
    ) {
      this.transactionOther = new TransactionOtherRefTracked(
        config.transactionOther,
        options,
      );
      if (optionsRequired.unassign) this.transactionOtherIsSet = false;
      else this.transactionOtherIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderPaymentFullTrackedI {
    const cloned = {} as OrderPaymentFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.paymentServiceChangeCentsIsSetDeep() &&
      this.paymentServiceChangeCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentServiceChangeCentsIsSet = true;
      cloned.paymentServiceChangeCents = this.paymentServiceChangeCents;
    } else {
      //cloned.paymentServiceChangeCentsIsSet = false
    }
    if (
      this.paymentCapturableCentsIsSetDeep() &&
      this.paymentCapturableCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableCentsIsSet = true;
      cloned.paymentCapturableCents = this.paymentCapturableCents;
    } else {
      //cloned.paymentCapturableCentsIsSet = false
    }
    if (
      this.paymentCapturableDateIsSetDeep() &&
      this.paymentCapturableDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentCapturableDateIsSet = true;
      cloned.paymentCapturableDate = this.paymentCapturableDate;
    } else {
      //cloned.paymentCapturableDateIsSet = false
    }
    if (
      this.paymentPaidCentsIsSetDeep() &&
      this.paymentPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidCentsIsSet = true;
      cloned.paymentPaidCents = this.paymentPaidCents;
    } else {
      //cloned.paymentPaidCentsIsSet = false
    }
    if (
      this.paymentTotalCentsIsSetDeep() &&
      this.paymentTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTotalCentsIsSet = true;
      cloned.paymentTotalCents = this.paymentTotalCents;
    } else {
      //cloned.paymentTotalCentsIsSet = false
    }
    if (
      this.paymentRefundedCentsIsSetDeep() &&
      this.paymentRefundedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRefundedCentsIsSet = true;
      cloned.paymentRefundedCents = this.paymentRefundedCents;
    } else {
      //cloned.paymentRefundedCentsIsSet = false
    }
    if (
      this.paymentToRefundCentsIsSetDeep() &&
      this.paymentToRefundCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentToRefundCentsIsSet = true;
      cloned.paymentToRefundCents = this.paymentToRefundCents;
    } else {
      //cloned.paymentToRefundCentsIsSet = false
    }
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentRecordIdIsSetDeep() &&
      this.paymentRecordIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentRecordIdIsSet = true;
      cloned.paymentRecordId = this.paymentRecordId;
    } else {
      //cloned.paymentRecordIdIsSet = false
    }
    if (
      this.paymentStatusIsSetDeep() &&
      this.paymentStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentStatusIsSet = true;
      cloned.paymentStatus = this.paymentStatus;
    } else {
      //cloned.paymentStatusIsSet = false
    }
    if (
      this.paymentDueDateIsSetDeep() &&
      this.paymentDueDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentDueDateIsSet = true;
      cloned.paymentDueDate = this.paymentDueDate;
    } else {
      //cloned.paymentDueDateIsSet = false
    }
    if (
      this.paymentPaidDateIsSetDeep() &&
      this.paymentPaidDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentPaidDateIsSet = true;
      cloned.paymentPaidDate = this.paymentPaidDate;
    } else {
      //cloned.paymentPaidDateIsSet = false
    }
    if (
      this.squarePaymentIdIsSetDeep() &&
      this.squarePaymentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squarePaymentIdIsSet = true;
      cloned.squarePaymentId = this.squarePaymentId;
    } else {
      //cloned.squarePaymentIdIsSet = false
    }
    if (
      this.expiresOnIsSetDeep() &&
      this.expiresOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.expiresOnIsSet = true;
      cloned.expiresOn = this.expiresOn;
    } else {
      //cloned.expiresOnIsSet = false
    }
    if (
      this.paymentSourceIsSetDeep() &&
      this.paymentSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentSourceIsSet = true;
      cloned.paymentSource = this.paymentSource?.removeUnset(filter);
    } else {
      //cloned.paymentSourceIsSet = false
    }
    if (
      this.stripeTransactionIsSetDeep() &&
      this.stripeTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripeTransactionIsSet = true;
      cloned.stripeTransaction = this.stripeTransaction?.removeUnset(filter);
    } else {
      //cloned.stripeTransactionIsSet = false
    }
    if (
      this.cashTransactionIsSetDeep() &&
      this.cashTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashTransactionIsSet = true;
      cloned.cashTransaction = this.cashTransaction?.removeUnset(filter);
    } else {
      //cloned.cashTransactionIsSet = false
    }
    if (
      this.balanceTransactionIsSetDeep() &&
      this.balanceTransactionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTransactionIsSet = true;
      cloned.balanceTransaction = this.balanceTransaction?.removeUnset(filter);
    } else {
      //cloned.balanceTransactionIsSet = false
    }
    if (
      this.transactionOtherIsSetDeep() &&
      this.transactionOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionOtherIsSet = true;
      cloned.transactionOther = this.transactionOther?.removeUnset(filter);
    } else {
      //cloned.transactionOtherIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderPaymentFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.paymentServiceChangeCentsApplyFilter(filter))
      this.paymentServiceChangeCentsIsSet = false;

    if (!this.paymentCapturableCentsApplyFilter(filter))
      this.paymentCapturableCentsIsSet = false;

    if (!this.paymentCapturableDateApplyFilter(filter))
      this.paymentCapturableDateIsSet = false;

    if (!this.paymentPaidCentsApplyFilter(filter))
      this.paymentPaidCentsIsSet = false;

    if (!this.paymentTotalCentsApplyFilter(filter))
      this.paymentTotalCentsIsSet = false;

    if (!this.paymentRefundedCentsApplyFilter(filter))
      this.paymentRefundedCentsIsSet = false;

    if (!this.paymentToRefundCentsApplyFilter(filter))
      this.paymentToRefundCentsIsSet = false;

    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentRecordIdApplyFilter(filter))
      this.paymentRecordIdIsSet = false;

    if (!this.paymentStatusApplyFilter(filter)) this.paymentStatusIsSet = false;

    if (!this.paymentDueDateApplyFilter(filter))
      this.paymentDueDateIsSet = false;

    if (!this.paymentPaidDateApplyFilter(filter))
      this.paymentPaidDateIsSet = false;

    if (!this.squarePaymentIdApplyFilter(filter))
      this.squarePaymentIdIsSet = false;

    if (!this.expiresOnApplyFilter(filter)) this.expiresOnIsSet = false;

    if (!this.paymentSourceApplyFilter(filter)) this.paymentSourceIsSet = false;
    this.paymentSource?.unassignAll(filter);

    if (!this.stripeTransactionApplyFilter(filter))
      this.stripeTransactionIsSet = false;
    this.stripeTransaction?.unassignAll(filter);

    if (!this.cashTransactionApplyFilter(filter))
      this.cashTransactionIsSet = false;
    this.cashTransaction?.unassignAll(filter);

    if (!this.balanceTransactionApplyFilter(filter))
      this.balanceTransactionIsSet = false;
    this.balanceTransaction?.unassignAll(filter);

    if (!this.transactionOtherApplyFilter(filter))
      this.transactionOtherIsSet = false;
    this.transactionOther?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.isDeleted,
      OrderPaymentFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.isNew,
      OrderPaymentFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.assignId,
      OrderPaymentFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  paymentServiceChangeCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentServiceChangeCents,
      OrderPaymentFullMeta,
      this.paymentServiceChangeCents,
      this,
    );
  }
  paymentServiceChangeCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentServiceChangeCentsIsSet &&
      this.paymentServiceChangeCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentCapturableCents,
      OrderPaymentFullMeta,
      this.paymentCapturableCents,
      this,
    );
  }
  paymentCapturableCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableCentsIsSet &&
      this.paymentCapturableCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentCapturableDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentCapturableDate,
      OrderPaymentFullMeta,
      this.paymentCapturableDate,
      this,
    );
  }
  paymentCapturableDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentCapturableDateIsSet &&
      this.paymentCapturableDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentPaidCents,
      OrderPaymentFullMeta,
      this.paymentPaidCents,
      this,
    );
  }
  paymentPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidCentsIsSet && this.paymentPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  paymentTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentTotalCents,
      OrderPaymentFullMeta,
      this.paymentTotalCents,
      this,
    );
  }
  paymentTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTotalCentsIsSet &&
      this.paymentTotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentRefundedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentRefundedCents,
      OrderPaymentFullMeta,
      this.paymentRefundedCents,
      this,
    );
  }
  paymentRefundedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentRefundedCentsIsSet &&
      this.paymentRefundedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentToRefundCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentToRefundCents,
      OrderPaymentFullMeta,
      this.paymentToRefundCents,
      this,
    );
  }
  paymentToRefundCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentToRefundCentsIsSet &&
      this.paymentToRefundCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentType,
      OrderPaymentFullMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentRecordIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentRecordId,
      OrderPaymentFullMeta,
      this.paymentRecordId,
      this,
    );
  }
  paymentRecordIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentRecordIdIsSet && this.paymentRecordIdApplyFilter(filter))
      return true;

    return false;
  }
  paymentStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentStatus,
      OrderPaymentFullMeta,
      this.paymentStatus,
      this,
    );
  }
  paymentStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentStatusIsSet && this.paymentStatusApplyFilter(filter))
      return true;

    return false;
  }
  paymentDueDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentDueDate,
      OrderPaymentFullMeta,
      this.paymentDueDate,
      this,
    );
  }
  paymentDueDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentDueDateIsSet && this.paymentDueDateApplyFilter(filter))
      return true;

    return false;
  }
  paymentPaidDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentPaidDate,
      OrderPaymentFullMeta,
      this.paymentPaidDate,
      this,
    );
  }
  paymentPaidDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentPaidDateIsSet && this.paymentPaidDateApplyFilter(filter))
      return true;

    return false;
  }
  squarePaymentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.squarePaymentId,
      OrderPaymentFullMeta,
      this.squarePaymentId,
      this,
    );
  }
  squarePaymentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squarePaymentIdIsSet && this.squarePaymentIdApplyFilter(filter))
      return true;

    return false;
  }
  expiresOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.expiresOn,
      OrderPaymentFullMeta,
      this.expiresOn,
      this,
    );
  }
  expiresOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.expiresOnIsSet && this.expiresOnApplyFilter(filter)) return true;

    return false;
  }
  paymentSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.paymentSource,
      OrderPaymentFullMeta,
      this.paymentSource,
      this,
    );
  }
  paymentSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentSourceIsSet && this.paymentSourceApplyFilter(filter))
      return true;
    return this.paymentSource?.anySet(filter) == true;

    return false;
  }
  stripeTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.stripeTransaction,
      OrderPaymentFullMeta,
      this.stripeTransaction,
      this,
    );
  }
  stripeTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.stripeTransactionIsSet &&
      this.stripeTransactionApplyFilter(filter)
    )
      return true;
    return this.stripeTransaction?.anySet(filter) == true;

    return false;
  }
  cashTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.cashTransaction,
      OrderPaymentFullMeta,
      this.cashTransaction,
      this,
    );
  }
  cashTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashTransactionIsSet && this.cashTransactionApplyFilter(filter))
      return true;
    return this.cashTransaction?.anySet(filter) == true;

    return false;
  }
  balanceTransactionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.balanceTransaction,
      OrderPaymentFullMeta,
      this.balanceTransaction,
      this,
    );
  }
  balanceTransactionIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceTransactionIsSet &&
      this.balanceTransactionApplyFilter(filter)
    )
      return true;
    return this.balanceTransaction?.anySet(filter) == true;

    return false;
  }
  transactionOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentFullMeta.transactionOther,
      OrderPaymentFullMeta,
      this.transactionOther,
      this,
    );
  }
  transactionOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionOtherIsSet && this.transactionOtherApplyFilter(filter))
      return true;
    return this.transactionOther?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.paymentServiceChangeCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableCentsIsSetDeep(filter)) return true;
    if (this.paymentCapturableDateIsSetDeep(filter)) return true;
    if (this.paymentPaidCentsIsSetDeep(filter)) return true;
    if (this.paymentTotalCentsIsSetDeep(filter)) return true;
    if (this.paymentRefundedCentsIsSetDeep(filter)) return true;
    if (this.paymentToRefundCentsIsSetDeep(filter)) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentRecordIdIsSetDeep(filter)) return true;
    if (this.paymentStatusIsSetDeep(filter)) return true;
    if (this.paymentDueDateIsSetDeep(filter)) return true;
    if (this.paymentPaidDateIsSetDeep(filter)) return true;
    if (this.squarePaymentIdIsSetDeep(filter)) return true;
    if (this.expiresOnIsSetDeep(filter)) return true;
    if (this.paymentSourceIsSetDeep(filter)) return true;
    if (this.stripeTransactionIsSetDeep(filter)) return true;
    if (this.cashTransactionIsSetDeep(filter)) return true;
    if (this.balanceTransactionIsSetDeep(filter)) return true;
    if (this.transactionOtherIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
